































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import { getCollectionEventById, CollectionEventDetailsModel, getCollectionEventImage, GetCollectionEventImageResponse } from "@/api/CollectionEvents";
import CollectionEventDetailsDialog from "@/components/CollectionEvents/CollectionEventDetailsDialog.vue";
import ExpandableImage from "@/components/ExpandableImage/ExpandableImage.vue";
import CollectionEventDetailsHeader from "@/components/CollectionEvents/CollectionEventDetailsHeader.vue";
import CollectionEventDetailsList from "@/components/CollectionEvents/CollectionEventDetailsList.vue";
import { LoadingStore } from "@/store/loadingStore";
import mapStore from "@/store/mapStore";
import orderBy from "lodash/orderBy";
import notificationStore from "@/store/notificationStore";
import { arePointsClose } from "@/helpers/LatituteLongitutehelper";

@Observer
@Component({ components: { CollectionEventDetailsDialog, CollectionEventDetailsHeader, CollectionEventDetailsList, ExpandableImage } })
export default class CollectionEventSummary extends Vue {
  @Prop(Number) readonly collectionEventId: number | undefined;
  @Prop(Boolean) readonly isCollectionIssue: boolean | undefined;
  @Prop(Number) readonly collectionEventType: number | undefined;
  isDetailsDialogOpen = false;
  loading = new LoadingStore();
  details: CollectionEventDetailsModel | null = null;
  image: GetCollectionEventImageResponse | null = null;
  mapStore = mapStore;

  @Watch("collectionEventId")
  async onCollectionEventIdChanged() {
    await this.loading.track(async () => {
      try {
        if (this.collectionEventId && this.isCollectionIssue !== undefined && this.collectionEventType !== undefined) {
          this.image = null;
          const getCollectionEventPromise = getCollectionEventById({
            collectionEventId: this.collectionEventId,
            isCollectionIssue: this.isCollectionIssue,
            collectionEventType: this.collectionEventType
          });
          if (this.isCollectionIssue) {
            const getCollectionEventImagePromise = getCollectionEventImage({ collectionEventId: this.collectionEventId, collectionEventType: this.collectionEventType });
            this.image = await getCollectionEventImagePromise;
          }
          this.details = await getCollectionEventPromise;
        } else this.details = null;
      } catch (error) {
        notificationStore.error("An unexpected error occurred while loading the issue details");
      }
    });
  }

  get nearbyCollections() {
    if (!this.details) {
      return [];
    }
    return orderBy(
      mapStore.collectionEvents.filter(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ce =>
          arePointsClose(ce.latitude, ce.longitude, this.details!.latitude, this.details!.longitude) &&
          ce.addressHash.trim() !== "" &&
          ce.addressHash.toLowerCase().indexOf("unknown") === -1 &&
          mapStore.isEventVisible(ce)
      ),
      "addressHash"
    );
  }

  get thisIndex() {
    if (!this.details) return null;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.nearbyCollections.findIndex(c => c.id === this.details!.id);
  }

  get next() {
    if (this.thisIndex === null) return null;
    if (this.thisIndex < this.nearbyCollections.length - 1) {
      return this.nearbyCollections[this.thisIndex + 1];
    }
    return null;
  }

  get previous() {
    if (this.thisIndex === null) return null;
    if (this.thisIndex >= 1) {
      return this.nearbyCollections[this.thisIndex - 1];
    }
    return null;
  }

  minHeight() {
    return this.isCollectionIssue ? "403px" : "203px";
  }
}
